import linkLabelDo from "../../../../src/images/snippets/link-label-do.png";
import linkLabelDont from "../../../../src/images/snippets/link-label-dont.png";
import * as React from 'react';
export default {
  linkLabelDo,
  linkLabelDont,
  React
};